/**
 * Cart icon is an <a href="/cart"> so it still works without JS.
 * Theme Drawer.open() cancels that navigation; this capture listener is a
 * safety net (theme.js may be served stale via Hyperspeed) so a second click
 * or a click after ATC cannot fall through to the cart page.
 * Cmd/Ctrl/Shift/middle-click still follow the href.
 */
(function preventDrawerTriggerNavigation() {
  if (window.__sparkPawsDrawerTriggerGuard) return;
  window.__sparkPawsDrawerTriggerGuard = true;

  document.addEventListener('click', function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;

    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (!node || !node.closest) return;

    var trigger = node.closest('a[href][data-action="open-drawer"][data-drawer-id]');
    if (!trigger) return;

    var drawer = document.getElementById(trigger.getAttribute('data-drawer-id'));
    if (!drawer) return;

    event.preventDefault();
  }, true);
})();

/**
 * Header cart dot must follow Shopify's real cart, not theme memory or mini-cart HTML.
 * theme.js is often served stale via Hyperspeed; this file is not.
 * XHR /cart.js avoids UpCart's window.fetch wrapper.
 */
(function syncHeaderCartDotFromShopify() {
  if (window.__sparkPawsHeaderCartDotSync) return;
  window.__sparkPawsHeaderCartDotSync = true;

  var lastServerCount = null;
  var debounceTimer = null;

  function cartJsUrl() {
    var base = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
    return base + '.js?t=' + Date.now();
  }

  function applyCount(count) {
    count = parseInt(count, 10);
    if (isNaN(count) || count < 0) count = 0;
    lastServerCount = count;

    var dots = document.querySelectorAll('.Header__CartDot');
    for (var i = 0; i < dots.length; i++) {
      if (count === 0) dots[i].classList.remove('is-visible');
      else dots[i].classList.add('is-visible');
    }

    var quantities = document.querySelectorAll('.Header__CartCount');
    for (var j = 0; j < quantities.length; j++) {
      quantities[j].textContent = String(count);
    }
  }

  function readCartJs() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', cartJsUrl());
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
      if (xhr.status < 200 || xhr.status >= 300) return;
      try {
        var cart = JSON.parse(xhr.responseText);
        if (cart && typeof cart.item_count === 'number') applyCount(cart.item_count);
      } catch (e) {}
    };
    xhr.send();
  }

  function refresh() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      readCartJs();
    }, 150);
  }

  function refreshSoon() {
    refresh();
    window.setTimeout(readCartJs, 450);
    window.setTimeout(readCartJs, 1100);
  }

  function isCartMutationTarget(node) {
    if (!node || !node.closest) return false;
    return !!(
      node.closest('[data-action="remove-item"]') ||
      node.closest('[data-action="update-item-quantity"]') ||
      node.closest('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]') ||
      node.closest('.PageOverlay') ||
      node.closest('.Header__Icon[data-drawer-id="sidebar-cart"]')
    );
  }

  document.addEventListener('click', function (event) {
    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (!isCartMutationTarget(node)) return;
    refreshSoon();
  }, true);

  document.addEventListener('product:added', function () {
    lastServerCount = null;
    refreshSoon();
  });
  document.addEventListener('cart:refresh', refresh);

  window.addEventListener('pageshow', function () {
    readCartJs();
  });

  function bindUpcart() {
    if (window.__sparkPawsDotUpcartBound) return false;
    if (typeof window.upcartSubscribeCartUpdated !== 'function') return false;
    window.__sparkPawsDotUpcartBound = true;

    window.upcartSubscribeCartUpdated(function (event) {
      var cart = event && event.cart;
      if (cart && Array.isArray(cart.items)) {
        var count = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var qty = cart.items[i] && cart.items[i].quantity;
          count += typeof qty === 'number' ? qty : 0;
        }
        applyCount(count);
      }
      refreshSoon();
    });

    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded(function () {
        refreshSoon();
      });
    }

    if (typeof window.upcartCloseCart === 'function' && !window.upcartCloseCart.__sparkPawsDotWrapped) {
      var nativeClose = window.upcartCloseCart.bind(window);
      var wrappedClose = function () {
        var result = nativeClose.apply(this, arguments);
        refreshSoon();
        return result;
      };
      wrappedClose.__sparkPawsDotWrapped = true;
      window.upcartCloseCart = wrappedClose;
    }

    return true;
  }

  bindUpcart();
  var tries = 0;
  var poll = window.setInterval(function () {
    tries += 1;
    if (bindUpcart() || tries > 80) window.clearInterval(poll);
  }, 250);

  function guardAgainstStaleClass() {
    if (window.__sparkPawsDotClassGuard) return;
    var root = document.getElementById('shopify-section-header') || document.body;
    if (!root) return;
    window.__sparkPawsDotClassGuard = true;
    new MutationObserver(function () {
      if (lastServerCount !== 0) return;
      var dots = document.querySelectorAll('.Header__CartDot');
      for (var i = 0; i < dots.length; i++) {
        if (dots[i].classList.contains('is-visible')) {
          dots[i].classList.remove('is-visible');
        }
      }
    }).observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function start() {
    guardAgainstStaleClass();
    readCartJs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// jQuery namespace + AbortController so Product Set Dog/Human re-inits do not stack handlers.
var SPARK_PAWS_JQ_NS = '.sparkPawsTheme';
var sparkPawsThemeRuntime = {
  abortController: null,
  generation: 0,
  manualListeners: []
};

function teardownSparkPawsTheme() {
  sparkPawsThemeRuntime.generation += 1;

  if (sparkPawsThemeRuntime.abortController) {
    try {
      sparkPawsThemeRuntime.abortController.abort();
    } catch (e) {}
    sparkPawsThemeRuntime.abortController = null;
  }

  if (sparkPawsThemeRuntime.manualListeners && sparkPawsThemeRuntime.manualListeners.length) {
    sparkPawsThemeRuntime.manualListeners.forEach(function (entry) {
      try {
        entry.target.removeEventListener(entry.type, entry.handler, entry.options);
      } catch (e) {}
    });
    sparkPawsThemeRuntime.manualListeners = [];
  }

  // Undo any leftover dispatchEvent monkey-patch from media filtering (survives Dog/Human swap).
  restoreProductVariantDispatch();

  // Persistent UI (size guide modal / links) + product forms that may survive a swap.
  $('.template-product #size-guide-link').off(SPARK_PAWS_JQ_NS);
  $('.template-product #measurements-link').off(SPARK_PAWS_JQ_NS);
  $('#custom-model-main .close-btn, #custom-model-main .bg-overlay').off(SPARK_PAWS_JQ_NS);
  $('#custom-model-main .tabs__button[data-tab^="tab-content-"]').off(SPARK_PAWS_JQ_NS);
  $('[data-product-set-size-guide] .close-btn, [data-product-set-size-guide] .bg-overlay').off(SPARK_PAWS_JQ_NS);
  $('[data-product-set-size-guide] .tabs__button[data-tab^="tab-content-"]').off(SPARK_PAWS_JQ_NS);
  $('.ProductForm .ProductForm__Option').off(SPARK_PAWS_JQ_NS);
  $('.ProductForm .HorizontalList__Item input').off(SPARK_PAWS_JQ_NS);
  $('.ProductForm .HorizontalList__Item label').off(SPARK_PAWS_JQ_NS);
  $('.ProductForm .HorizontalList__Item select').off(SPARK_PAWS_JQ_NS);
  $('.ProductForm select[name=id]').off(SPARK_PAWS_JQ_NS);
}

/**
 * Media filter temporarily suppresses variant:changed on .Product.
 * Always restore via Element.prototype so wrappers never nest / recurse on re-entry.
 */
function restoreProductVariantDispatch() {
  var roots = document.querySelectorAll('[data-product-set-root], .Product');
  for (var i = 0; i < roots.length; i++) {
    var el = roots[i];
    if (!el) continue;
    if (el._originalDispatchEvent || (el.dispatchEvent && el.dispatchEvent._sparkPawsPatched)) {
      el.dispatchEvent = Element.prototype.dispatchEvent;
      delete el._originalDispatchEvent;
    }
  }
}

function patchProductVariantDispatch(productElement, shouldSuppress) {
  if (!productElement || typeof shouldSuppress !== 'function') return;

  // Never wrap an existing wrapper — restore first, then bind to the native method.
  restoreProductVariantDispatch();

  var nativeDispatch = Element.prototype.dispatchEvent;
  productElement._originalDispatchEvent = nativeDispatch;

  var patched = function (event) {
    if (event && event.type === 'variant:changed' && shouldSuppress()) {
      return false;
    }
    return nativeDispatch.call(this, event);
  };
  patched._sparkPawsPatched = true;
  productElement.dispatchEvent = patched;
}

// HubSpot-compatible initialization
function initializeSparkPawsTheme() {
    teardownSparkPawsTheme();

    var sparkGeneration = sparkPawsThemeRuntime.generation;
    sparkPawsThemeRuntime.abortController =
      typeof AbortController !== 'undefined' ? new AbortController() : null;
    var sparkSignal = sparkPawsThemeRuntime.abortController
      ? sparkPawsThemeRuntime.abortController.signal
      : null;

    function sparkListen(target, type, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      var opts = options ? Object.assign({}, options) : {};
      if (sparkSignal) {
        opts.signal = sparkSignal;
        target.addEventListener(type, handler, opts);
        return;
      }
      target.addEventListener(type, handler, opts);
      sparkPawsThemeRuntime.manualListeners.push({
        target: target,
        type: type,
        handler: handler,
        options: opts
      });
    }

    function isSparkGenerationCurrent() {
      return sparkGeneration === sparkPawsThemeRuntime.generation;
    }

    $(".template-product #size-guide-link").addClass( "animal-link" );

    $(".template-product #size-guide-link.animal-link").on("click" + SPARK_PAWS_JQ_NS, function(e){
       if (this.hasAttribute('data-sg3-open')) return;
       e.preventDefault();

       $("body").addClass('modal-opened');
       $("#custom-model-main").addClass('model-open');
       $("#custom-model-main .bg-overlay").addClass('bg-overlay--active');
       
       // Show size guide tab if tabs exist (supports Product Set member-suffixed ids)
       $("#custom-model-main .tabs__button[data-tab^='tab-content-size-guide-images']").addClass('is-active');
       $("#custom-model-main .tabs__button[data-tab^='tab-content-measurements-images']").removeClass('is-active');
       $("#custom-model-main [id^='tab-content-size-guide-images']").addClass('is-active');
       $("#custom-model-main [id^='tab-content-measurements-images']").removeClass('is-active');
    });

    // How to Measure button handler
    $(".template-product #measurements-link").addClass( "animal-link" );

    $(".template-product #measurements-link.animal-link").on("click" + SPARK_PAWS_JQ_NS, function(e){
       e.preventDefault();

       $("body").addClass('modal-opened');
       $("#custom-model-main").addClass('model-open');
       $("#custom-model-main .bg-overlay").addClass('bg-overlay--active');
       
       // Show measurements tab if tabs exist (supports Product Set member-suffixed ids)
       $("#custom-model-main .tabs__button[data-tab^='tab-content-measurements-images']").addClass('is-active');
       $("#custom-model-main .tabs__button[data-tab^='tab-content-size-guide-images']").removeClass('is-active');
       $("#custom-model-main [id^='tab-content-measurements-images']").addClass('is-active');
       $("#custom-model-main [id^='tab-content-size-guide-images']").removeClass('is-active');
    });

    $("#custom-model-main .close-btn, #custom-model-main .bg-overlay").on("click" + SPARK_PAWS_JQ_NS, function(){
      $("body").removeClass('modal-opened');
      $("#custom-model-main").removeClass('model-open');
      $("#custom-model-main .bg-overlay").removeClass('bg-overlay--active');
    });
    
    // Tab switching for image guide tabs
    $("#custom-model-main .tabs__button[data-tab^='tab-content-']").on("click" + SPARK_PAWS_JQ_NS, function(){
      var tabId = $(this).attr('data-tab');
      $("#custom-model-main .tabs__button[data-tab^='tab-content-']").removeClass('is-active');
      $(this).addClass('is-active');
      $("#custom-model-main .tabs__body .tabs__panel[id^='tab-content-']").removeClass('is-active');
      $("#custom-model-main #" + tabId).addClass('is-active');
    });

    const size_labels = ["size","taille","größe","tamanho","tamaño","koko","サイズ"];
    const color_labels = ["color","colour","couleur","colore","farbe","색","色","färg","farve"];
    
    // Helper function to normalize labels for comparison
    const normalizeLabel = (label) => label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    const detectDisabledVariants = () => {
        $(".ProductForm .HorizontalList__Item, #bundle-option-1 option,  #bundle-option-2 option").removeClass("disabled").attr("disabled", false);
        
        // Explicitly ensure all color options are enabled
        $(".ProductForm .ColorSwatch__Radio").each(function() {
            $(this).closest("li").removeClass("disabled");
            $(this).prop("disabled", false);
        });
        // Exclude Product Set Family Member radios (SizeSwatch__Radio used for Dog/Human UI only).
        const current_variants = $(".ProductForm .HorizontalList__Item .SizeSwatch__Radio:checked:not([data-product-set-member]), #bundle-option-1 option:selected, .ProductForm .HorizontalList__Item .ColorSwatch__Radio:checked").toArray().map(item => $(item).val());
        const options_elements = $(".ProductForm .ProductForm__Option:not(.no-js, .ProductForm__Option--ignore)").toArray().map(item => $(item).find(".SizeSwatch__Radio:not([data-product-set-member]), .ColorSwatch__Radio, #bundle-option-1 option").toArray());

        options_elements.forEach((opts, i) => { // Going through every row of options
            // Get the label text, but exclude size guide links and selected value spans
            const labelElement = $(opts[0]).closest(".ProductForm__Option").find(".ProductForm__Label");
            let label = labelElement.clone()
                .find('a, .ProductForm__SelectedValue, span').remove().end()
                .text().trim().replace(":","").toLowerCase();
            // Normalize German umlauts and other special characters for proper comparison
            const normalizedLabel = normalizeLabel(label);
            const is_color = color_labels.some(colorLabel => normalizeLabel(colorLabel) === normalizedLabel);
            $(opts).each(function(){ // Going through every option in a row
                // Getting option's title and position
                const opt = {title: $(this).val(), position: parseInt($(this).attr("data-option-position"))};
                if(opt.title !== current_variants[i]){ // Checking if this option is not currently selected/active
                    let opt_var = [opt];
                    current_variants.forEach((vrnt,x) => { // Going through every currently selected option and combining them with option
                        if(x + 1 !== opt.position){ // Verifying that it's the option from a different row and not the row of the current option
                            opt_var.push({title: vrnt, position: x+1});
                        }
                    });
                    opt_var = opt_var.sort((a,b) => a.position - b.position);
                    const opts_name = opt_var.map(item => item.title).join(" / "); // Constructing a name of a possible variant
                    // Try to find variant by constructed title first, then by option1/option2 match
                    let the_variant = variants.filter(cvariant => cvariant.title == opts_name)[0];
                    
                    // If not found by title, try matching by option1/option2 values
                    if (!the_variant && opt_var.length >= 2) {
                        const option1 = opt_var.find(opt => opt.position === 1)?.title;
                        const option2 = opt_var.find(opt => opt.position === 2)?.title;
                        the_variant = variants.find(variant => 
                            variant.option1 === option1 && variant.option2 === option2
                        );
                    }
                    
                    if(!the_variant?.available && !is_color){ // Verifying if the variant is not available
                        // Disabling the option (but never disable colors)
                        if($(this).closest("select").length > 0) {
                            if(opt.title !== "none") $(`option[value='${opt.title}']`).attr("disabled", true);
                        }
                        else if(!is_color) { // Double check - only disable if it's NOT a color
                            $(this).closest("li").addClass("disabled");
                        }
                    }
                    if(is_color){
                        // Don't disable color options - keep them all available
                        // Color options will be handled by size switching logic
                    }
                }
            })
        });
        
        // Final cleanup - absolutely ensure no color options are disabled
        $(".ProductForm .ColorSwatch__Radio").each(function() {
            $(this).closest("li").removeClass("disabled");
            $(this).prop("disabled", false);
        });
    }


    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
    }

    const countBundlePrice = () => {
        if($("#bundle-option-1").length){
            const options = $("#bundle-option-1 option:selected, #bundle-option-2 option:selected").toArray().map(item => { return {title: $(item).text(), position: parseInt($(item).attr("data-option-position"))}});
            const current_variants = $(".HorizontalList__Item .SizeSwatch__Radio:checked:not([data-product-set-member])").toArray().map(item => { return {title: $(item).val(), position: parseInt($(item).attr("data-option-position"))}});
            let total_price = 0;
            let unavailable = false;
            options.forEach(option => {
                const opt = [option];
                current_variants.forEach(cur => {
                    if(cur.position !== option.position) opt.push(cur);
                });
                const opt_name = opt.sort((a,b) => a.position - b.position).map(item => item.title).join(" / ");
                const corresponding_variant = variants.filter(item => item.title == opt_name)[0];
                if(corresponding_variant?.available){
                    total_price += corresponding_variant.price;
                } else if(option.title == "None"){
                    total_price += 0;
                } else {
                    unavailable = true;
                }
            });
            const price = formatMoney(total_price, window.theme.moneyFormat);
            if(unavailable){
                $(".ProductForm__AddToCart").removeClass("Button--primary").addClass("Button--secondary").attr("disabled",true);
                $(".ProductForm__AddToCart").html(`<span>${window.languages.productFormSoldOut}</span>`);
            } else {
                $(".ProductForm__AddToCart").removeClass("Button--secondary").addClass("Button--primary").attr("disabled",false);
                $(".ProductForm__AddToCart").html(`<span>${window.languages.productFormAddToCart}</span>
                <span class="Button__SeparatorDot"></span>
                <span data-money-convertible="">${price}</span>`);
            }
        }
    };

    detectDisabledVariants();
    countBundlePrice();
    $(".ProductForm .ProductForm__Option").on('change' + SPARK_PAWS_JQ_NS, function() {
        detectDisabledVariants();
        countBundlePrice();
    });
    $(".ProductForm .HorizontalList__Item").each(function(){
        const label = $(this).find("label");
        const input = $(this).find("input");
        const select = $(this).find("select");
        function blockIfSoldOut(e) {
            if (!$(this).hasClass("disabled")) return false;
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            return true;
        }
        input.on("pointerdown" + SPARK_PAWS_JQ_NS + " click" + SPARK_PAWS_JQ_NS, (e) => {
            if (blockIfSoldOut.call(this, e)) return;
            detectDisabledVariants();
        })
        label.on("pointerdown" + SPARK_PAWS_JQ_NS + " click" + SPARK_PAWS_JQ_NS, (e) => {
            if (blockIfSoldOut.call(this, e)) return;
            detectDisabledVariants();
        })
        select.on("pointerdown" + SPARK_PAWS_JQ_NS + " click" + SPARK_PAWS_JQ_NS + " change" + SPARK_PAWS_JQ_NS, (e) => {
            if (blockIfSoldOut.call(this, e)) return;
            detectDisabledVariants();
        })
    });

    $(".ProductForm select[name=id]").on("change" + SPARK_PAWS_JQ_NS, function(){
        if($("preorder-button").length > 0){
            const variant_id = $(this).find("option:selected").attr("value");
            $("preorder-button").attr("variant_id", variant_id);
            $("preorder-button input[name=id]").val(variant_id);
        }
    });

    let extras;
    // $(".template-cart .Container").on("DOMSubtreeModified", function(){
    //     if($(this).find(".CustomCartExtras").length == 0){
    //         if(!extras || extras?.length == 0){
    //             extras = $(".CustomCartExtras").detach();
    //         } need to check why this commented out 

    //         $("form.Cart .Cart__ItemList").after(extras);
    //         $(".CustomCartExtras").show();
    //         initExtras();
    //     }
    // });

    // $(".Drawer").on("DOMSubtreeModified", function(){
    //     if($(this).find(".Cart .CustomCartExtras").length == 0){
    //         if(!extras || extras?.length == 0){
    //             extras = $(".CustomCartExtras").detach();
    //         }
    //         if($(this).find(".Cart__Empty").length == 0){
    //             $(".Drawer .Cart .Drawer__Main").append(extras);
    //             $(".CustomCartExtras").show();
    //             initExtras();
    //         }

    //     }
    // });

    function initExtras() {

        $(".CustomExtras__Options").each(function(){
            const inner = $(this).next();
            $(this).on("click", function(){
                $(this).hide();
                inner.show();
            });
            const select = inner.find(".CustomExtras__Option select");
            const info = $(this).closest(".CartItem__Info");
            const price = info.find(".CartItem__Price");
            select.on("change", function(){
                const selected_option = $(`option[value=${$(this).val()}]`);
                price.text(selected_option.attr("data-price"));
            });
            const buy = inner.find(".CustomExtras__Buy");
            buy.on("click", function(){
                let formData = {
                    'items': [{
                        'id': select.val(),
                        'quantity': 1
                    }]
                };
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    if(response.status == 200) window.location.href = window.location.href;
                })
                .catch((error) => {
                    // Error handling
                });
            });
        });

    }


    function getPdpRoot() {
        return document.querySelector('[data-product-set-root]') || document;
    }
    function pdpQuery(selector) {
        var root = getPdpRoot();
        if (root !== document && root.matches && root.matches(selector)) return root;
        return root.querySelector(selector);
    }
    function pdpQueryAll(selector) {
        var root = getPdpRoot();
        if (root !== document && root.matches && root.matches(selector)) {
            var list = root.querySelectorAll(selector);
            if (list.length) return list;
            return [root];
        }
        return root.querySelectorAll(selector);
    }
    function excludeBundleControls(list) {
        return Array.prototype.filter.call(list || [], function (el) {
            return !isBundleOptionControl(el);
        });
    }
    let colorSwatches = excludeBundleControls(pdpQueryAll('.ProductForm .ColorSwatch'));
    let sizeSwatches = excludeBundleControls(pdpQueryAll('.ProductForm .SizeSwatch:not([data-product-set-member-label])'));
    const formVariants = pdpQuery('.ProductForm__Variants');
    const firstOptionTarget = formVariants ? (formVariants.getAttribute('data-first-option-target') || '') : '';
    let navButtons = pdpQueryAll('.Product__SlideshowNavArrow');
    let forClick = '';
    let forClickSize = '';
    let navColor = '';
    let navSize = '';
    let currentElColor = '';
    let currentElSize = '';
    let selectedImage = false;
    let isManualThumbClick = false;
    let isFilteringSlides = false;
    
    // Cache for slide management
    let allSlidesCache = [];
    let currentSlidesInFlickity = new Set();
    
    function getProductData() {
        var el = null;
        var form = pdpQuery('.ProductForm');
        if (form) {
            var inForm = form.querySelector('[data-product-json]');
            if (inForm && !isBundleOptionControl(inForm)) el = inForm;
        }
        if (!el) {
            var candidates = pdpQueryAll('[data-product-json]');
            for (var i = 0; i < candidates.length; i++) {
                if (!isBundleOptionControl(candidates[i])) {
                    el = candidates[i];
                    break;
                }
            }
        }
        if (!el) return null;
        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            return null;
        }
    }

    function normalizeOptionKey(name) {
        return String(name || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function getOptionNameList(product) {
        const options = (product && product.options) || [];
        return options.map((opt) => {
            if (typeof opt === 'string') return opt;
            if (opt && typeof opt === 'object' && opt.name) return String(opt.name);
            return '';
        }).filter(Boolean);
    }

    function optionValueAtPosition(variant, position) {
        if (!variant || position == null) return '';
        if (position === 1) return variant.option1 ? String(variant.option1).trim() : '';
        if (position === 2) return variant.option2 ? String(variant.option2).trim() : '';
        if (position === 3) return variant.option3 ? String(variant.option3).trim() : '';
        return '';
    }

    function getVariantMediaOptions(variant, product) {
        const result = {};
        getOptionNameList(product).forEach((name, index) => {
            const key = normalizeOptionKey(name);
            const value = optionValueAtPosition(variant, index + 1);
            if (key && value) result[key] = value;
        });
        return result;
    }

    function isBundleOptionControl(el) {
        return !!(el && el.closest && el.closest('.product-bundles, .product-item-bundles, .product-bundle'));
    }

    function getSelectedMediaOptionsFromForm() {
        const productData = getProductData();
        const product = productData && productData.product;
        const result = {};
        if (!product) return result;

        const optionNames = getOptionNameList(product);
        const form = pdpQuery('.ProductForm');
        if (!form) return result;

        var variantRoot = null;
        var variantBlocks = form.querySelectorAll('.ProductForm__Variants');
        for (var i = 0; i < variantBlocks.length; i++) {
            if (!isBundleOptionControl(variantBlocks[i])) {
                variantRoot = variantBlocks[i];
                break;
            }
        }
        if (!variantRoot) return result;

        variantRoot.querySelectorAll('input[type="radio"][name^="option-"]:checked').forEach((radio) => {
            let position = parseInt(radio.getAttribute('data-option-position'), 10);
            if (!position || isNaN(position)) {
                const nameMatch = (radio.getAttribute('name') || '').match(/^option-(\d+)$/);
                if (nameMatch) {
                    position = parseInt(nameMatch[1], 10) + 1;
                }
            }
            const optionName = optionNames[position - 1];
            if (!optionName) return;
            const key = normalizeOptionKey(optionName);
            const value = (radio.value || '').trim();
            if (key && value) result[key] = value;
        });

        return result;
    }

    function getMediaOptionsWithOverride(optionPosition, optionValue) {
        const options = getSelectedMediaOptionsFromForm();
        const productData = getProductData();
        const optionNames = getOptionNameList(productData && productData.product);
        const key = normalizeOptionKey(optionNames[optionPosition - 1]);
        if (key && optionValue) options[key] = String(optionValue).trim();
        return options;
    }

    function getLegacyFirstOptionKey() {
        if (firstOptionTarget) return normalizeOptionKey(firstOptionTarget);
        return 'color';
    }

    function getProductOptionKeys() {
        const productData = getProductData();
        return getOptionNameList(productData && productData.product).map((name) => normalizeOptionKey(name));
    }

    function parseMediaAlt(alt, legacyFirstOptionKey) {
        const result = {};
        const trimmed = (alt || '').trim().replace(/\n/g, '');
        if (!trimmed) return result;

        const legacyKey = legacyFirstOptionKey || getLegacyFirstOptionKey();
        const optionKeys = getProductOptionKeys();
        const parts = trimmed.split('||').map((part) => part.trim()).filter(Boolean);
        const allUnkeyed = parts.every((part) => part.indexOf(':') <= 0);
        const usePositionalLegacy = allUnkeyed && parts.length >= 2;

        parts.forEach((part, index) => {
            const colonIndex = part.indexOf(':');
            if (colonIndex > 0) {
                const key = normalizeOptionKey(part.slice(0, colonIndex));
                const rawValue = part.slice(colonIndex + 1).trim();
                result[key] = rawValue.split(',').map((value) => value.trim()).filter(Boolean);
            } else if (usePositionalLegacy && optionKeys[index]) {
                // Legacy positional: Red||No Handle||S → option1, option2, option3
                result[optionKeys[index]] = [part];
            } else if (index === 0) {
                // Legacy single color or mixed first segment: Purple Shirt / Red||size:S
                result[legacyKey] = [part];
            } else if (optionKeys[index]) {
                // Legacy mixed with extra unkeyed segments: Red||No Handle||size:S
                result[optionKeys[index]] = [part];
            }
        });

        return result;
    }

    const COLOR_OPTION_ALIASES = ['color', 'colour', 'couleur', 'colore', 'farbe', 'färg', 'farve'];

    function keysMatchAltToOption(altKey, optionKey) {
        if (altKey === optionKey) return true;
        if (COLOR_OPTION_ALIASES.includes(altKey) && COLOR_OPTION_ALIASES.includes(optionKey)) return true;
        const sizeAliases = ['size', 'sizes', 'taille', 'größe', 'tamanho', 'tamaño'];
        if (sizeAliases.includes(altKey) && sizeAliases.includes(optionKey)) return true;
        const typeAliases = ['type', 'types', 'style'];
        if (typeAliases.includes(altKey) && typeAliases.includes(optionKey)) return true;
        return false;
    }

    function findSelectedValueForAltKey(altKey, selectedMediaOptions) {
        if (!selectedMediaOptions || typeof selectedMediaOptions !== 'object') return '';
        if (selectedMediaOptions[altKey]) return selectedMediaOptions[altKey];
        for (const optionKey in selectedMediaOptions) {
            if (keysMatchAltToOption(altKey, optionKey)) return selectedMediaOptions[optionKey];
        }
        return '';
    }

    function mediaMatchesSelectedOptions(parsedAlt, selectedMediaOptions) {
        if (!parsedAlt || Object.keys(parsedAlt).length === 0) return true;

        const productKeys = getProductOptionKeys();
        const hasSelections = selectedMediaOptions && Object.keys(selectedMediaOptions).length > 0;

        for (const altKey in parsedAlt) {
            const allowedValues = parsedAlt[altKey];
            if (!allowedValues || !allowedValues.length) continue;

            const appliesToProduct = productKeys.some(function (productKey) {
                return keysMatchAltToOption(altKey, productKey);
            });
            const selectedValue = findSelectedValueForAltKey(altKey, selectedMediaOptions);

            if (appliesToProduct && hasSelections) {
                if (!selectedValue) {
                    return false;
                }
                const selectedDown = String(selectedValue).trim().toLowerCase();
                const matched = allowedValues.some(function (value) {
                    return String(value).trim().toLowerCase() === selectedDown;
                });
                if (!matched) return false;
                continue;
            }

            if (!selectedValue) continue;

            const selectedDown = String(selectedValue).trim().toLowerCase();
            const matched = allowedValues.some(function (value) {
                return String(value).trim().toLowerCase() === selectedDown;
            });
            if (!matched) return false;
        }

        return true;
    }

    function altHasStructuredOptions(trimmed) {
        if (!trimmed) return false;
        if (trimmed.indexOf('||') !== -1) return true;
        return trimmed.split('||').some(function (part) {
            const colonIndex = part.indexOf(':');
            return colonIndex > 0;
        });
    }

    function shouldShowMediaForAlt(imageAlt, selectedMediaOptions, titleForEmptyCheck) {
        const title = (titleForEmptyCheck != null ? titleForEmptyCheck : '').toLowerCase();
        if (isAltEffectivelyEmpty(imageAlt, title)) return true;

        const trimmed = (imageAlt || '').trim().replace(/\n/g, '');
        if (!trimmed) return true;

        const parsed = parseMediaAlt(trimmed);

        if (altHasStructuredOptions(trimmed) && Object.keys(parsed).length > 0) {
            return mediaMatchesSelectedOptions(parsed, selectedMediaOptions);
        }

        const { color: selectedColor, size: selectedSize } = getSelectedColorAndSize(selectedMediaOptions);
        const legacyKey = getLegacyFirstOptionKey();
        const colorValues = parsed[legacyKey] || parsed.color;
        const altColor = (colorValues && colorValues[0])
            ? colorValues[0]
            : (trimmed.indexOf(':') === -1 && trimmed.indexOf('||') === -1 ? trimmed : null);

        if (selectedColor && altColor && altColor.toLowerCase() !== selectedColor.toLowerCase()) {
            return false;
        }

        const sizeValues = parsed.size || parsed.sizes;
        if (selectedSize && sizeValues && sizeValues.length) {
            const sizeDown = selectedSize.toLowerCase();
            const sizeOk = sizeValues.some(function (size) {
                return String(size).trim().toLowerCase() === sizeDown;
            });
            if (!sizeOk) return false;
        }

        if (Object.keys(parsed).length > 0) {
            return mediaMatchesSelectedOptions(parsed, selectedMediaOptions);
        }

        return true;
    }

    function isAltEffectivelyEmpty(alt, productTitle) {
        const trimmed = (alt || '').trim().replace(/\n/g, '');
        return trimmed === '' || trimmed.toLowerCase() === (productTitle || '').toLowerCase();
    }

    function getMediaAltById(mediaId) {
        const productData = getProductData();
        const product = productData && productData.product;
        if (!product || !product.media || mediaId == null) return '';
        const media = product.media.find(function (item) {
            return String(item.id) === String(mediaId);
        });
        return (media && media.alt ? media.alt : '').trim().replace(/\n/g, '');
    }

  /**
   * Stack PDP disables Flickity (watchCSS); slides stay in the DOM with visibility:visible.
   * Default PDP may also leave non-carousel slides in the DOM. Hide/show by alt + selection.
   */
    function syncDomMediaVisibility(selectedMediaOptions) {
        const currentOptions = selectedMediaOptions || getSelectedMediaOptionsFromForm();
        if (!currentOptions || Object.keys(currentOptions).length === 0) return;

        pdpQueryAll('.Product__SlideItem--image').forEach(function (slide) {
            // Product Set container hero: only while still present and not dismissed.
            if (slide.getAttribute('data-product-set-hero') === 'true') {
                var setRoot = document.querySelector('[data-product-set-root]');
                if (!slide.isConnected || (setRoot && setRoot.getAttribute('data-product-set-hero-dismissed') === 'true')) {
                    slide.style.setProperty('display', 'none', 'important');
                    slide.classList.add('Product__SlideItem--mediaFilterHidden');
                    return;
                }
                slide.style.removeProperty('display');
                slide.classList.remove('Product__SlideItem--mediaFilterHidden');
                return;
            }

            const mediaId = slide.getAttribute('data-media-id');
            const img = slide.querySelector('img');
            const alt = getMediaAltById(mediaId)
                || (img && img.getAttribute('alt') ? img.getAttribute('alt') : '');
            const show = isAltEffectivelyEmpty(alt, productTitle)
                || shouldShowMediaForAlt(alt, currentOptions, productTitle);

            if (show) {
                slide.style.removeProperty('display');
                slide.classList.remove('Product__SlideItem--mediaFilterHidden');
            } else {
                slide.style.setProperty('display', 'none', 'important');
                slide.classList.add('Product__SlideItem--mediaFilterHidden');
            }
        });

        pdpQueryAll('.Product__SlideshowNavImage').forEach(function (thumb) {
            if (thumb.getAttribute('data-product-set-hero') === 'true') {
                var setRootThumb = document.querySelector('[data-product-set-root]');
                if (!thumb.isConnected || (setRootThumb && setRootThumb.getAttribute('data-product-set-hero-dismissed') === 'true')) {
                    thumb.classList.remove('Product__SlideshowNavImage--show');
                    thumb.classList.remove('is-selected');
                    return;
                }
                thumb.classList.add('Product__SlideshowNavImage--show');
                return;
            }

            const mediaId = thumb.getAttribute('data-media-id');
            const img = thumb.querySelector('img');
            const alt = getMediaAltById(mediaId)
                || (img && img.getAttribute('alt') ? img.getAttribute('alt') : '');
            const show = isAltEffectivelyEmpty(alt, productTitle)
                || shouldShowMediaForAlt(alt, currentOptions, productTitle);

            thumb.classList.toggle('Product__SlideshowNavImage--show', show);
            if (!show) {
                thumb.classList.remove('is-selected');
            }
        });
    }

    /**
     * Extract color (+ optional sizes) from media alt.
     * Supports: "Waffle Blue" and "Ash Blue Waffle Grey||size:S,M,L,XL,2XL"
     */
    function extractMediaColorAndSizes(alt, titleForEmptyCheck) {
        const trimmed = (alt || '').trim().replace(/\n/g, '');
        const title = (titleForEmptyCheck != null ? titleForEmptyCheck : productTitle) || '';
        if (!trimmed || trimmed.toLowerCase() === title.toLowerCase()) {
            return { color: null, sizes: null, empty: true };
        }

        if (trimmed.indexOf('||') !== -1 || /^(color|colour)\s*:/i.test(trimmed)) {
            const parts = trimmed.split('||').map((part) => part.trim()).filter(Boolean);
            let color = null;
            let sizes = null;

            parts.forEach((part, index) => {
                const sizeMatch = part.match(/^size:\s*(.+)$/i);
                if (sizeMatch) {
                    sizes = sizeMatch[1].split(',').map((value) => value.trim()).filter(Boolean);
                    return;
                }
                const colorMatch = part.match(/^(?:color|colour)\s*:\s*(.+)$/i);
                if (colorMatch) {
                    color = colorMatch[1].trim();
                    return;
                }
                // Legacy: Red||No Handle||S
                if (index === 0 && part.indexOf(':') === -1) {
                    color = part;
                }
            });

            return { color: color, sizes: sizes, empty: false };
        }

        // Color-only alt (no || and no key:)
        if (trimmed.indexOf(':') === -1) {
            return { color: trimmed, sizes: null, empty: false };
        }

        const parsed = parseMediaAlt(trimmed);
        const colorKey = getLegacyFirstOptionKey();
        const colorArr = parsed[colorKey] || parsed.color;
        return {
            color: colorArr && colorArr[0] ? colorArr[0] : null,
            sizes: parsed.size || null,
            empty: false
        };
    }

    function getSelectedColorAndSize(selectedMediaOptions) {
        const options = selectedMediaOptions && typeof selectedMediaOptions === 'object'
            ? selectedMediaOptions
            : {};
        const color = findSelectedValueForAltKey(getLegacyFirstOptionKey(), options)
            || findSelectedValueForAltKey('color', options)
            || '';
        const size = findSelectedValueForAltKey('size', options) || '';
        return { color: color, size: size };
    }

    // Resolve product title for treating Shopify's auto-filled alt as effectively empty
    const productTitleRaw = pdpQuery('.ProductMeta__Title')?.innerText
        || pdpQuery('.Product__Info .SectionHeader__Heading')?.innerText
        || document.title;
    const productTitle = (productTitleRaw || '').trim().toLowerCase();

    function getImageUrlFromMedia(media) {
        if (!media) return '';
        let src = media.src
            || (media.preview_image && media.preview_image.src)
            || '';
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        if (src.indexOf('width=') !== -1) {
            src = src.replace(/([?&])width=\d+/i, '$1width=900');
        } else {
            src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=900';
        }
        return src;
    }

    const DESKTOP_GRID_MAX = 6;

    function buildOrderedMediaList(filtered, featuredMediaId, maxCount) {
        const featured = [];
        const rest = [];
        filtered.forEach((media) => {
            if (featuredMediaId && media.id === featuredMediaId) featured.push(media);
            else rest.push(media);
        });
        return featured.concat(rest).slice(0, maxCount || DESKTOP_GRID_MAX);
    }

    /**
     * Desktop grid: color/size matches first, then universal (empty / product-title alt)
     * shots as fillers. Universals-first was filling all 6 slots so the grid never
     * appeared to change on color switch.
     */
    function filterImagesForDesktopGrid(mediaList, currentOptions, maxCount, featuredMediaId) {
        const limit = maxCount || DESKTOP_GRID_MAX;
        const matches = [];
        const universals = [];

        mediaList.forEach((media) => {
            if (media.media_type && media.media_type !== 'image') return;
            const alt = (media.alt || '').trim().replace(/\n/g, '');

            if (isAltEffectivelyEmpty(alt, productTitle)) {
                universals.push(media);
                return;
            }

            if (shouldShowMediaForAlt(alt, currentOptions, productTitle)) {
                matches.push(media);
            }
        });

        return buildOrderedMediaList(matches.concat(universals), featuredMediaId, limit);
    }

    function applyDesktopGridImage(img, media, url, index) {
        if (!img || !media || !url) return;
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-widths');
        img.removeAttribute('sizes');
        img.removeAttribute('data-sizes');
        img.setAttribute('alt', media.alt || '');
        img.setAttribute('data-src', url);
        img.setAttribute('data-media-id', media.id);
        img.classList.remove('Image--lazyLoading');
        img.classList.add('Image--lazyLoad', 'Image--fadeIn');
        if (index < 2) {
            img.loading = 'eager';
            img.fetchPriority = 'high';
        } else {
            img.loading = 'lazy';
            img.fetchPriority = 'low';
        }
        img.src = url;
        if (typeof window.lazySizes !== 'undefined' && window.lazySizes.loader) {
            window.lazySizes.loader.unveil(img);
        }
    }

    function findVariantForMediaOptions(product, selectedMediaOptions) {
        if (!product || !product.variants || !selectedMediaOptions) return null;
        const optionNames = getOptionNameList(product);
        return product.variants.find((variant) => {
            return optionNames.every((name, index) => {
                const key = normalizeOptionKey(name);
                const selected = selectedMediaOptions[key];
                if (!selected) return true;
                return optionValueAtPosition(variant, index + 1) === selected;
            });
        }) || null;
    }

    function getSwatchMediaIdFromForm() {
        const form = pdpQuery('.ProductForm');
        if (!form) return null;
        let variantRoot = null;
        form.querySelectorAll('.ProductForm__Variants').forEach(function (block) {
            if (!variantRoot && !isBundleOptionControl(block)) variantRoot = block;
        });
        const radio = (variantRoot || form).querySelector('.ColorSwatch__Radio:checked');
        if (!radio || isBundleOptionControl(radio)) return null;
        const id = radio.getAttribute('data-swatch-media-id');
        return id ? String(id) : null;
    }

    function ensureSwatchMediaInList(mediaList, product, selectedMediaOptions) {
        const swatchId = getSwatchMediaIdFromForm();
        if (!swatchId || !product || !product.media) return mediaList;

        const found = product.media.find(function (media) { return String(media.id) === swatchId; });
        if (!found) return mediaList;

        const options = selectedMediaOptions || getSelectedMediaOptionsFromForm();
        const swatchAlt = (found.alt || '').trim();
        if (!isAltEffectivelyEmpty(swatchAlt, productTitle)
            && !shouldShowMediaForAlt(swatchAlt, options, productTitle)) {
            return mediaList;
        }

        const already = mediaList.some(function (media) { return String(media.id) === swatchId; });
        if (already) {
            const swatch = mediaList.filter(function (media) { return String(media.id) === swatchId; });
            const rest = mediaList.filter(function (media) { return String(media.id) !== swatchId; });
            return swatch.concat(rest);
        }

        return [found].concat(mediaList);
    }

    function updateDesktopGalleryGrid(selectedMediaOptions) {
        const gridEl = pdpQuery('[data-product-gallery-grid]');
        if (!gridEl) return;

        const productData = getProductData();
        const product = productData && productData.product;
        if (!product || !product.media) return;

        let currentOptions = selectedMediaOptions || getSelectedMediaOptionsFromForm();
        if (!currentOptions || typeof currentOptions !== 'object') {
            currentOptions = getSelectedMediaOptionsFromForm();
        }

        const variantIdInput = pdpQuery('.ProductForm input[name="id"]');
        const variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
        let variant = variantId ? product.variants.find((v) => v.id === variantId) : null;
        const matchedVariant = findVariantForMediaOptions(product, currentOptions);
        if (matchedVariant) variant = matchedVariant;

        // Form swatch state can lead hidden variant id; keep live radio selections authoritative
        if (variant) {
            currentOptions = Object.assign({}, getVariantMediaOptions(variant, product), currentOptions);
        }

        const featuredId = variant && variant.featured_media && variant.featured_media.id;
        const heroCell = gridEl.querySelector('.Product__GridItem[data-product-set-hero="true"]');
        const memberSlots = heroCell ? Math.max(DESKTOP_GRID_MAX - 1, 0) : DESKTOP_GRID_MAX;
        let orderedMedia = filterImagesForDesktopGrid(product.media, currentOptions, memberSlots, featuredId);
        orderedMedia = ensureSwatchMediaInList(orderedMedia, product, currentOptions).slice(0, memberSlots);
        const cells = gridEl.querySelectorAll('.Product__GridItem');

        cells.forEach((cell, index) => {
            // Hard cap: never show more than 6 grid images
            if (index >= DESKTOP_GRID_MAX) {
                cell.style.display = 'none';
                return;
            }

            // Keep Product Set container hero pinned as the first grid image.
            if (heroCell && cell.getAttribute('data-product-set-hero') === 'true') {
                cell.style.display = '';
                return;
            }

            const mediaIndex = heroCell ? index - 1 : index;
            const media = mediaIndex >= 0 ? orderedMedia[mediaIndex] : null;
            const img = cell.querySelector('img');

            if (media && img) {
                const url = getImageUrlFromMedia(media);
                if (url) {
                    const aspect = media.aspect_ratio || (media.preview_image && media.preview_image.aspect_ratio);
                    const ratioWrap = cell.querySelector('.AspectRatio');
                    if (ratioWrap && aspect) {
                        ratioWrap.style.paddingBottom = (100.0 / aspect) + '%';
                        ratioWrap.style.setProperty('--aspect-ratio', aspect);
                    }
                    cell.setAttribute('data-media-id', media.id);
                    cell.setAttribute('data-media-alt', media.alt || '');
                    applyDesktopGridImage(img, media, url, mediaIndex >= 0 ? mediaIndex : index);
                    cell.style.display = '';
                    return;
                }
            }

            cell.style.display = 'none';
        });
    }

    function restoreVariantChangedDispatch() {
        restoreProductVariantDispatch();
    }
    
    // Initialize slide cache — prefer product JSON alt (reliable for Color:Red||Type:…||size:…)
    function initializeSlideCache() {
        const productData = getProductData();
        const mediaAltById = {};
        if (productData && productData.product && productData.product.media) {
            productData.product.media.forEach(function (media) {
                mediaAltById[String(media.id)] = (media.alt || '').trim();
            });
        }

        var isProductSet = !!document.querySelector('[data-product-set-root]');
        var liveSlides = Array.from(pdpQueryAll('.Product__SlideItem--image'));
        var liveIds = {};
        liveSlides.forEach(function (slide) {
            var id = slide.getAttribute('data-media-id');
            if (id != null) liveIds[String(id)] = true;
        });

        // Product Set: after Dog/Human replace, initializeSparkPawsTheme filters once,
        // then __sparkPawsApplyProductSetMediaFilter calls initializeSlideCache again.
        // A naive rebuild from the live DOM drops slides already flkty.remove()'d
        // (disconnected). Keep those cached nodes when they belong to the *current*
        // member product so later Human/Dog size changes can flkty.insert them back.
        var preserved = [];
        if (isProductSet && productData && productData.product && productData.product.media) {
            var productMediaIds = {};
            productData.product.media.forEach(function (media) {
                if (media.media_type && media.media_type !== 'image') return;
                productMediaIds[String(media.id)] = true;
            });
            allSlidesCache.forEach(function (entry) {
                if (!entry || !entry.element || entry.mediaId == null) return;
                var id = String(entry.mediaId);
                if (liveIds[id]) return;
                if (!productMediaIds[id]) return;
                if (entry.element.isConnected) return;
                if (entry.element.getAttribute('data-product-set-hero') === 'true') return;
                preserved.push(entry);
            });
        }

        allSlidesCache = liveSlides.map(function (slide) {
            const mediaId = slide.getAttribute('data-media-id');
            const imgAlt = (slide.querySelector('img') && slide.querySelector('img').getAttribute('alt')) || '';
            return {
                element: slide,
                mediaId: mediaId,
                alt: (mediaAltById[String(mediaId)] || imgAlt || '').trim()
            };
        });

        if (preserved.length) {
            allSlidesCache = allSlidesCache.concat(preserved);
        }

        const flkty = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));
        if (flkty) {
            currentSlidesInFlickity = new Set(flkty.cells.map(cell => cell.element.getAttribute('data-media-id')).filter(Boolean));
        }
    }
    
    // Simple initialization filtering - get selected options from JSON and use the same function
    function filterSlidesForInitialization() {
        try {
            const productData = getProductData();
            if (!productData || !productData.product) return;

            const selectedVariant = productData.product.variants.find(
                (variant) => variant.id === productData.selected_variant_id
            );
            if (!selectedVariant) return;

            filterSlidesInFlickity(getVariantMediaOptions(selectedVariant, productData.product));
        } catch (e) {
            // Error during initialization filtering
        }
    }

    // Wait for Flickity (or desktop grid) before applying the initial alt-based filter.
    function waitForFlickityAndFilter(attempt) {
        if (!isSparkGenerationCurrent()) return;
        const tries = attempt || 0;
        const flkty = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));
        const hasGrid = !!pdpQuery('[data-product-gallery-grid]');

        if (flkty && flkty.cells && flkty.cells.length > 0) {
            const firstSlide = flkty.cells[0].element;
            if (firstSlide) {
                firstSlide.classList.remove('Product__SlideItem--hidden');
            }
            filterSlidesForInitialization();
            return;
        }

        if (hasGrid || tries >= 20) {
            filterSlidesForInitialization();
            return;
        }

        setTimeout(function() { waitForFlickityAndFilter(tries + 1); }, 100);
    }

    // Product Set Dog/Human reinit: expose the same ready-gated entry point.
    if (document.querySelector('[data-product-set-root]')) {
      window.__sparkPawsApplyProductSetMediaFilter = function () {
        if (!isSparkGenerationCurrent()) return;
        // After content-replaced, initializeSparkPawsTheme already built the cache
        // and may have filtered (disconnecting non-matching slides). Rebuilding from
        // the live DOM here would drop those nodes and break later Human size changes.
        if (!allSlidesCache.length) {
          initializeSlideCache();
        } else {
          var flktyExisting = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));
          if (flktyExisting) {
            currentSlidesInFlickity = new Set(
              flktyExisting.cells.map(function (cell) {
                return cell.element.getAttribute('data-media-id');
              }).filter(Boolean)
            );
          }
        }
        waitForFlickityAndFilter(0);
      };
      window.__sparkPawsEnsureProductSetGallerySelection = function () {
        if (!isSparkGenerationCurrent()) return;
        var flkty = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));
        syncProductSetGalleryAfterMediaChange(flkty, getSelectedMediaOptionsFromForm());
      };
      window.__sparkPawsSyncProductSetGallery = window.__sparkPawsEnsureProductSetGallerySelection;
    }

    /**
     * Product Set only: theme thumbnail clicks use selectCell(data-media-position - 1).
     * After alt filtering, Flickity cell indexes no longer match original positions —
     * renumber visible cells so navigation maps to the current gallery.
     */
    function syncProductSetMobileDots(flkty) {
        var mobileNav = pdpQuery('.Product__SlideshowMobileNav');
        if (!mobileNav || !flkty) return;

        var dotsContainer = mobileNav.querySelector('.flickity-page-dots');
        if (!dotsContainer) return;

        var cellCount = flkty.cells.length;
        var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.dot'));

        while (dots.length > cellCount) {
            var excess = dots.pop();
            if (excess && excess.parentNode) excess.parentNode.removeChild(excess);
        }
        while (dots.length < cellCount) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'dot';
            dotsContainer.appendChild(dot);
            dots.push(dot);
        }

        var selectedIndex = typeof flkty.selectedIndex === 'number' ? flkty.selectedIndex : 0;
        dots.forEach(function (dot, index) {
            dot.setAttribute('data-index', String(index));
            dot.classList.toggle('is-selected', index === selectedIndex);
        });
    }

    function syncProductSetFlickityMediaPositions(flkty) {
        if (!flkty || !flkty.cells) return;
        flkty.cells.forEach(function (cell, index) {
            if (!cell.element) return;
            // Keep the Liquid/original position for stable re-insert ordering after filters.
            if (!cell.element.getAttribute('data-media-position-original')) {
                cell.element.setAttribute(
                    'data-media-position-original',
                    cell.element.getAttribute('data-media-position') || String(index + 1)
                );
            }
            cell.element.setAttribute('data-media-position', String(index + 1));
        });
        syncProductSetMobileDots(flkty);
    }

    function getSlideSortPosition(slide) {
        if (!slide) return 0;
        var original = slide.getAttribute('data-media-position-original');
        if (original != null && original !== '') return parseInt(original, 10) || 0;
        return parseInt(slide.getAttribute('data-media-position') || '0', 10) || 0;
    }

    /**
     * Product Set only: after the visible media set changes, reinitialize gallery
     * selection the same way regular PDP does after filterSlidesInFlickity:
     * reload cells, force select(0), sync thumbs. Also renumber data-media-position
     * so any remaining theme selectCell(position-1) calls map to current cells.
     */
    function syncProductSetThumbnailSelectedState(flkty) {
        if (!flkty || !flkty.selectedElement) return;
        var mediaId = flkty.selectedElement.getAttribute('data-media-id');
        pdpQueryAll('.Product__SlideshowNavImage').forEach(function (thumb) {
            var match = mediaId && String(thumb.getAttribute('data-media-id')) === String(mediaId);
            thumb.classList.toggle('is-selected', !!match);
            if (match) thumb.classList.add('Product__SlideshowNavImage--show');
        });
    }

    function forceProductSetFirstSlide(flkty) {
        if (!flkty || !flkty.cells || !flkty.cells.length) return 0;

        var index = 0;
        if (!isProductSetHeroDismissed()) {
            for (var i = 0; i < flkty.cells.length; i++) {
                if (flkty.cells[i].element.getAttribute('data-product-set-hero') === 'true') {
                    index = i;
                    break;
                }
            }
        }

        flkty.cells.forEach(function (cell, cellIndex) {
            cell.element.classList.remove('Product__SlideItem--hidden');
            cell.element.classList.toggle('is-selected', cellIndex === index);
            cell.element.style.removeProperty('display');
        });

        // Same forced first-slide select regular PDP uses after filtering.
        try {
            flkty.select(index, true, true);
            flkty.resize();
            if (typeof flkty.reposition === 'function') flkty.reposition();
        } catch (e) {}

        return index;
    }

    function syncProductSetGalleryAfterMediaChange(flkty, selectedMediaOptions) {
        if (!document.querySelector('[data-product-set-root]')) return;

        var currentOptions = selectedMediaOptions || getSelectedMediaOptionsFromForm();
        flkty = flkty || (window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow')));

        if (!flkty || !flkty.cells || !flkty.cells.length) {
            ensureProductSetVisibleSelection(null, currentOptions);
            return;
        }

        syncProductSetFlickityMediaPositions(flkty);

        try {
            flkty.reloadCells();
            flkty.resize();
            if (typeof flkty.reposition === 'function') flkty.reposition();
        } catch (e) {}

        forceProductSetFirstSlide(flkty);
        syncProductSetMobileDots(flkty);
        syncProductSetThumbnailSelectedState(flkty);
        ensureProductSetVisibleSelection(flkty.selectedElement, currentOptions);

        // Theme ProductSection._updateSlideshowImage may select featured_media after
        // our filter (same event turn). Re-assert first slide like regular PDP's
        // post-filter select(0), without timers/polling loops.
        requestAnimationFrame(function () {
            var live = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));
            if (!live || !live.cells || !live.cells.length) return;
            if (!document.querySelector('[data-product-set-root]')) return;
            forceProductSetFirstSlide(live);
            syncProductSetMobileDots(live);
            syncProductSetThumbnailSelectedState(live);
        });
    }

    /**
     * Product Set only: navigate thumbs by current Flickity cell index (media-id),
     * matching the custom.js handlers regular PDP relies on after filtering — not
     * theme selectCell(data-media-position - 1), which goes stale after remove/insert.
     * One capture listener on the set root — no per-thumb stacking across filters.
     */
    function bindProductSetThumbnailNavigation() {
        var root = document.querySelector('[data-product-set-root]');
        if (!root) return;

        sparkListen(root, 'click', function (event) {
            var thumb = event.target && event.target.closest
                ? event.target.closest('.Product__SlideshowNavImage')
                : null;
            if (!thumb || !root.contains(thumb)) return;
            if (!thumb.classList.contains('Product__SlideshowNavImage--show')) return;

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            var flkty = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));
            if (!flkty || !flkty.cells || !flkty.cells.length) return;

            var thumbMediaId = String(thumb.getAttribute('data-media-id') || '');
            if (!thumbMediaId) return;

            var targetIndex = -1;
            for (var i = 0; i < flkty.cells.length; i++) {
                if (String(flkty.cells[i].element.getAttribute('data-media-id')) === thumbMediaId) {
                    targetIndex = i;
                    break;
                }
            }
            if (targetIndex < 0) return;

            isManualThumbClick = true;

            flkty.cells.forEach(function (cell, cellIndex) {
                cell.element.classList.remove('Product__SlideItem--hidden');
                cell.element.classList.toggle('is-selected', cellIndex === targetIndex);
            });

            try {
                flkty.select(targetIndex, true, true);
                flkty.resize();
                if (typeof flkty.reposition === 'function') flkty.reposition();
            } catch (e) {}

            pdpQueryAll('.Product__SlideshowNavImage').forEach(function (el) {
                el.classList.toggle('is-selected', el === thumb);
            });
            syncProductSetMobileDots(flkty);

            setTimeout(function () {
                isManualThumbClick = false;
            }, 100);
        }, true);
    }

    if (document.querySelector('[data-product-set-root]')) {
        bindProductSetThumbnailNavigation();
    }

    // Filter slides by adding/removing slides from Flickity based on current options
    function filterSlidesInFlickity(selectedMediaOptions) {
        try {
            const productData = getProductData();
            const product = productData && productData.product;
            const currentOptions = selectedMediaOptions || getSelectedMediaOptionsFromForm();
            
            // Don't filter if no options are selected
            if (!currentOptions || Object.keys(currentOptions).length === 0) {
                return;
            }

            const isProductSet = !!document.querySelector('[data-product-set-root]');
            
            // Set flag to prevent variant:changed events from interfering
            isFilteringSlides = true;
            
            // Temporarily override the dispatchEvent method to prevent variant:changed events
            const productElement = pdpQuery('.Product');
            if (productElement) {
                patchProductVariantDispatch(productElement, function () {
                    return isFilteringSlides;
                });
            }
            
            const flkty = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));
            // Desktop stack/grid disables Flickity via CSS watchCSS — filter DOM + grid
            if (!flkty) {
                syncDomMediaVisibility(currentOptions);
                updateDesktopGalleryGrid(currentOptions);
                if (isProductSet) {
                  ensureProductSetVisibleSelection(null, currentOptions);
                }
                isFilteringSlides = false;
                restoreVariantChangedDispatch();
                return;
            }
            
            
            // Get current slides in Flickity
            const currentSlides = Array.from(flkty.cells).map(cell => cell.element);
            const currentSlideIds = new Set(currentSlides.map(slide => slide.getAttribute('data-media-id')));
            const previouslySelected = flkty.selectedElement
              || pdpQuery('.Product__Slideshow .Product__SlideItem.is-selected');
            
            const slidesToRemove = [];
            const slidesToAdd = [];
            
            // Check all cached slides (use JSON alt from cache, not only img[alt]).
            // flkty.remove() disconnects nodes; they must still be eligible for flkty.insert()
            // on the next filter (same as custom-old.js). Do not skip !isConnected here —
            // that broke regular PDP size/color media swaps after the first filter.
            allSlidesCache.forEach(slide => {
                if (!slide.element) return;

                const imageAltTrimmed = (slide.alt || '').trim();
                const slideMediaId = slide.element.getAttribute('data-media-id');
                
                let shouldBeInFlickity = false;
                
                if (slide.element.getAttribute('data-product-set-hero') === 'true') {
                    var setRootFlickity = document.querySelector('[data-product-set-root]');
                    // Dismissed Set hero must never re-enter the carousel.
                    shouldBeInFlickity = !!(setRootFlickity
                        && setRootFlickity.getAttribute('data-product-set-hero-dismissed') !== 'true'
                        && slide.element.isConnected);
                } else if (isAltEffectivelyEmpty(imageAltTrimmed, productTitle)) {
                    shouldBeInFlickity = true;
                } else {
                    shouldBeInFlickity = shouldShowMediaForAlt(imageAltTrimmed, currentOptions, productTitle);
                }
                
                const isCurrentlyInFlickity = currentSlideIds.has(slideMediaId);
                
                if (shouldBeInFlickity && !isCurrentlyInFlickity) {
                    slidesToAdd.push(slide.element);
                } else if (!shouldBeInFlickity && isCurrentlyInFlickity) {
                    slidesToRemove.push(slide.element);
                }
            });
            
            const mediaSetChanged = slidesToRemove.length > 0 || slidesToAdd.length > 0;
            
            // Remove slides that shouldn't be there
            slidesToRemove.forEach(slide => {
                flkty.remove(slide);
                currentSlidesInFlickity.delete(slide.getAttribute('data-media-id'));
            });
            
            // Add slides that should be there in their original positions
            slidesToAdd.forEach(slide => {
                const mediaId = slide.getAttribute('data-media-id');
                if (!slide.getAttribute('data-media-position-original')) {
                    slide.setAttribute(
                        'data-media-position-original',
                        slide.getAttribute('data-media-position') || '0'
                    );
                }
                
                // Find the correct position to insert based on original gallery order
                const slidePosition = getSlideSortPosition(slide);
                let insertIndex = flkty.cells.length; // Default to end
                
                for (let i = 0; i < flkty.cells.length; i++) {
                    const cellPosition = getSlideSortPosition(flkty.cells[i].element);
                    if (slidePosition < cellPosition) {
                        insertIndex = i;
                        break;
                    }
                }
                
                // Insert at the correct position
                flkty.insert(slide, insertIndex);
                currentSlidesInFlickity.add(mediaId);
            });
            
            const selectionLost = !previouslySelected
              || !previouslySelected.isConnected
              || slidesToRemove.indexOf(previouslySelected) !== -1
              || (previouslySelected.getAttribute
                && previouslySelected.getAttribute('data-product-set-hero') === 'true');

            function restoreFlickityCellVisibility() {
                flkty.cells.forEach(function (cell) {
                    if (!cell.element) return;
                    cell.element.style.removeProperty('display');
                    cell.element.classList.remove('Product__SlideItem--hidden');
                    cell.element.classList.remove('Product__SlideItem--mediaFilterHidden');
                });
            }

            restoreFlickityCellVisibility();

            // Reload and resize if changes were made, or Product Set lost its selected slide
            if (mediaSetChanged || (isProductSet && selectionLost)) {
                flkty.reloadCells();
                restoreFlickityCellVisibility();
                flkty.resize();
                if (typeof flkty.reposition === 'function') flkty.reposition();
                
                // Regular PDP (and Product Set pre-sync): always land on first cell of new set.
                if (flkty.cells.length > 0) {
                setTimeout(() => {
                    if (flkty.cells.length > 0) {
                        restoreFlickityCellVisibility();
                        const firstSlide = flkty.cells[0].element;
                        const originalSelectCell = flkty.selectCell;
                        flkty.selectCell = function(index) {
                            this.select(index, true, true);
                        };
                        flkty.select(0, true, true);
                        flkty.resize();
                        setTimeout(() => {
                            flkty.selectCell = originalSelectCell;
                        }, 100);
                            firstSlide.classList.remove('Product__SlideItem--hidden');
                      }
                  }, 0);
                }
            }
            
            // Clear the flag and restore original dispatchEvent after filtering is complete
            setTimeout(() => {
                isFilteringSlides = false;
                restoreVariantChangedDispatch();
            }, 600);
            
            // Filter thumbnails visibility to match the filtered media set
            let selectedImage = false;
            const swatchIdForThumbs = getSwatchMediaIdFromForm();

            pdpQueryAll('.Product__SlideshowNavImage').forEach(function(elemFirst) {
        elemFirst.classList.remove('Product__SlideshowNavImage--show');
                elemFirst.classList.remove('is-selected');
                
                const thumbMediaId = elemFirst.getAttribute('data-media-id');
                const img = elemFirst.querySelector('img');
                const imageAltTrimmed = (getMediaAltById(thumbMediaId) || (img && img.getAttribute('alt')) || '').trim();
                
                let shouldShow = false;
                if (elemFirst.getAttribute('data-product-set-hero') === 'true') {
                    shouldShow = elemFirst.isConnected && !isProductSetHeroDismissed();
                } else if (isAltEffectivelyEmpty(imageAltTrimmed, productTitle)) {
                    shouldShow = true;
                } else {
                    shouldShow = shouldShowMediaForAlt(imageAltTrimmed, currentOptions, productTitle);
                }
                
                if (shouldShow) {
          elemFirst.classList.add('Product__SlideshowNavImage--show');
                    
                    // Product Set: visibility only here — gallery sync selects first slide below.
                    if (!isProductSet && !selectedImage && !isManualThumbClick) {
                        if (!swatchIdForThumbs || String(thumbMediaId) === swatchIdForThumbs) {
                            elemFirst.classList.add('is-selected');
                        elemFirst.click();
                        selectedImage = true;
                        }
                    }
                }
            });

            if (!isProductSet && !selectedImage && !isManualThumbClick) {
                const firstVisibleThumb = pdpQuery('.Product__SlideshowNavImage.Product__SlideshowNavImage--show');
                if (firstVisibleThumb) {
                    firstVisibleThumb.classList.add('is-selected');
                      firstVisibleThumb.click();
                    selectedImage = true;
                }
            }

            syncDomMediaVisibility(currentOptions);
            updateDesktopGalleryGrid(currentOptions);

            if (isProductSet) {
              // Match regular PDP post-filter reinit: reload → select first → thumb sync,
              // plus position renumber + capture-phase thumb nav by cell index.
              syncProductSetGalleryAfterMediaChange(flkty, currentOptions);
            }
            
        } catch (e) {
            try {
                updateDesktopGalleryGrid(selectedMediaOptions || getSelectedMediaOptionsFromForm());
            } catch (gridErr) {}
        }
    }

    /**
     * Product Set only: keep Flickity on a real visible slide.
     * While the Set hero is still active (not dismissed), prefer it as the selected cell.
     * After dismiss, select the first valid Dog/Human slide.
     */
    function isProductSetHeroDismissed() {
        var root = document.querySelector('[data-product-set-root]');
        return !!(root && root.getAttribute('data-product-set-hero-dismissed') === 'true');
    }

    function ensureProductSetFlickitySelection(flkty, selectedMediaOptions) {
        if (!document.querySelector('[data-product-set-root]')) return;
        if (!flkty || !flkty.cells || !flkty.cells.length) {
          ensureProductSetVisibleSelection(null, selectedMediaOptions);
          return;
        }

        const currentOptions = selectedMediaOptions || getSelectedMediaOptionsFromForm();
        const heroDismissed = isProductSetHeroDismissed();
        let targetIndex = -1;

        // Initial load / pre-dismiss: Set hero stays first and selected.
        if (!heroDismissed) {
          for (let i = 0; i < flkty.cells.length; i++) {
            const el = flkty.cells[i].element;
            if (el && el.isConnected && el.getAttribute('data-product-set-hero') === 'true') {
              targetIndex = i;
              break;
            }
          }
        }

        if (targetIndex < 0) {
          for (let i = 0; i < flkty.cells.length; i++) {
            const el = flkty.cells[i].element;
            if (!el || !el.isConnected) continue;
            if (el.getAttribute('data-product-set-hero') === 'true') continue;
            if (el.classList.contains('Product__SlideItem--mediaFilterHidden')) continue;
            if (el.style.display === 'none') continue;

            const mediaId = el.getAttribute('data-media-id');
            const img = el.querySelector('img');
            const alt = (getMediaAltById(mediaId)
              || (img && img.getAttribute('alt'))
              || '').trim();
            const ok = !currentOptions || !Object.keys(currentOptions).length
              || isAltEffectivelyEmpty(alt, productTitle)
              || shouldShowMediaForAlt(alt, currentOptions, productTitle);
            if (!ok) continue;

            targetIndex = i;
            break;
          }
        }

        if (targetIndex < 0) targetIndex = 0;

        flkty.cells.forEach(function (cell) {
          cell.element.classList.remove('Product__SlideItem--hidden');
          cell.element.classList.remove('is-selected');
        });

        const target = flkty.cells[targetIndex].element;
        target.classList.add('is-selected');
        target.classList.remove('Product__SlideItem--hidden');
        target.style.removeProperty('display');

        try {
          flkty.reloadCells();
          flkty.select(targetIndex, true, true);
          flkty.resize();
          if (typeof flkty.reposition === 'function') flkty.reposition();
        } catch (e) {}

        const mediaId = target.getAttribute('data-media-id');
        pdpQueryAll('.Product__SlideshowNavImage').forEach(function (thumb) {
          const match = mediaId && thumb.getAttribute('data-media-id') === mediaId;
          thumb.classList.toggle('is-selected', !!match);
          if (match) thumb.classList.add('Product__SlideshowNavImage--show');
        });

        ensureProductSetVisibleSelection(target, currentOptions);
    }

    function ensureProductSetVisibleSelection(preferredSlide, selectedMediaOptions) {
        if (!document.querySelector('[data-product-set-root]')) return;

        const currentOptions = selectedMediaOptions || getSelectedMediaOptionsFromForm();
        const heroDismissed = isProductSetHeroDismissed();
        let target = preferredSlide && preferredSlide.isConnected ? preferredSlide : null;

        if (!target && !heroDismissed) {
          target = Array.from(pdpQueryAll('.Product__Slideshow .Product__SlideItem')).find(function (slide) {
            return slide.getAttribute('data-product-set-hero') === 'true';
          }) || null;
        }

        if (!target) {
          const slides = Array.from(pdpQueryAll('.Product__Slideshow .Product__SlideItem'));
          target = slides.find(function (slide) {
            if (slide.getAttribute('data-product-set-hero') === 'true') return false;
            if (slide.classList.contains('Product__SlideItem--mediaFilterHidden')) return false;
            if (slide.style.display === 'none') return false;
            const mediaId = slide.getAttribute('data-media-id');
            const img = slide.querySelector('img');
            const alt = (getMediaAltById(mediaId)
              || (img && img.getAttribute('alt'))
              || '').trim();
            return !currentOptions || !Object.keys(currentOptions).length
              || isAltEffectivelyEmpty(alt, productTitle)
              || shouldShowMediaForAlt(alt, currentOptions, productTitle);
          }) || slides.find(function (slide) {
            return slide.getAttribute('data-product-set-hero') !== 'true';
          }) || null;
        }

        if (!target) return;

        pdpQueryAll('.Product__Slideshow .Product__SlideItem').forEach(function (slide) {
          slide.classList.remove('Product__SlideItem--hidden');
          slide.classList.toggle('is-selected', slide === target);
        });
        target.style.removeProperty('display');
    }

    sparkListen(document, 'variant:changed', function(event) {
        if (!isSparkGenerationCurrent()) return;
        // On Product Set pages, ignore events that are not from the active set root.
        var eventTarget = event.target;
        if (eventTarget && eventTarget.nodeType === 1 && eventTarget.closest
            && eventTarget.closest('.product-bundles, .product-item-bundles, .product-bundle')) {
          return;
        }
        var productSetRoot = document.querySelector('[data-product-set-root]');
        if (productSetRoot) {
          if (eventTarget && eventTarget.nodeType === 1 && !productSetRoot.contains(eventTarget)) {
            return;
          }
        }

        const variant = event.detail && event.detail.variant;
        const productData = getProductData();
        if (!variant || !productData || !productData.product) return;

        const options = Object.assign(
            {},
            getSelectedMediaOptionsFromForm(),
            getVariantMediaOptions(variant, productData.product)
        );

        const flktyLive = window.Flickity && Flickity.data(pdpQuery('.Product__Slideshow'));

        // display:none on slides still in Flickity collapses adaptiveHeight to 0 (mobile slider vanishes).
        if (!flktyLive) {
            syncDomMediaVisibility(options);
        }

        if (pdpQuery('[data-product-gallery-grid]')) {
            updateDesktopGalleryGrid(options);
        }

        if (pdpQuery('.Product__Slideshow')) {
            filterSlidesInFlickity(options);
        }
    });

    (function initDesktopGalleryGrid() {
        const gridEl = pdpQuery('[data-product-gallery-grid]');
        const productData = getProductData();
        if (!gridEl || !productData || !productData.product) return;

        const selectedVariant = productData.product.variants.find(
            (variant) => variant.id === productData.selected_variant_id
        );
        if (selectedVariant) {
            const opts = getVariantMediaOptions(selectedVariant, productData.product);
            syncDomMediaVisibility(opts);
            updateDesktopGalleryGrid(opts);
        }
    })();

    if(colorSwatches.length > 0 || sizeSwatches.length > 0 || firstOptionTarget){
      let colorSkuArr = excludeBundleControls(pdpQueryAll('.ProductForm .ColorSwatch__Radio'));
      let sizeSkuArr = excludeBundleControls(pdpQueryAll('.ProductForm .SizeSwatch__Radio:not([data-product-set-member])'));
      let colorSkuFirst = 0;
      let sizeSkuFirst = 0;

      if (firstOptionTarget) {
        // First option (e.g. Type) = filter like color; second = size. Same alt format: "With Handle||size:S"
        const opt0 = pdpQuery('.ProductForm input[name="option-0"]:checked');
        const opt1 = pdpQuery('.ProductForm input[name="option-1"]:checked');
        forClick = opt0 ? opt0.value : '';
        forClickSize = opt1 ? opt1.value : '';
      } else {
    if(colorSwatches.length > 0){
      colorSkuArr.forEach((el) => {
            if(el.getAttribute('checked') == 'checked')
            colorSkuFirst = el.nextElementSibling.querySelector("span").innerText;
            forClick = colorSkuFirst;
        });
      }
      if(sizeSkuArr.length > 0){
        sizeSkuArr.forEach((el) => {
            if(el.getAttribute('checked') == 'checked')
            sizeSkuFirst = el.nextElementSibling.innerText;
            forClickSize = sizeSkuFirst;
        });
        }
      }

      // Initialize slide cache before processing images
      initializeSlideCache();

      // Thumbnail filtering is now handled in filterSlidesInFlickity function
      waitForFlickityAndFilter(0);

      if (firstOptionTarget) {
        // Listen to all option changes and filter slides dynamically
        function applyFirstOptionFilter() {
          const opt0 = pdpQuery('.ProductForm input[name="option-0"]:checked');
          const opt1 = pdpQuery('.ProductForm input[name="option-1"]:checked');
          forClick = opt0 ? opt0.value : '';
          forClickSize = opt1 ? opt1.value : '';
          isFilteringSlides = true;
          const options = getSelectedMediaOptionsFromForm();
          updateDesktopGalleryGrid(options);
          filterSlidesInFlickity(options);
          setTimeout(function() { isFilteringSlides = false; restoreVariantChangedDispatch(); }, 700);
        }
        pdpQueryAll('.ProductForm input[name^="option-"]').forEach(function(radio) {
          sparkListen(radio, 'change', function() {
            if (radio.closest && radio.closest('li.disabled')) return;
            applyFirstOptionFilter();
          });
        });
          } else {

      // Filter on radio change (after checked state updates) — avoids one-click lag on label click
      colorSkuArr.forEach(function(radio) {
        sparkListen(radio, 'change', function() {
          selectedImage = false;
          forClick = radio.value;
          isFilteringSlides = true;
          const position = parseInt(radio.getAttribute('data-option-position'), 10) || 1;
          const options = getMediaOptionsWithOverride(position, radio.value);
          updateDesktopGalleryGrid(options);
          filterSlidesInFlickity(options);
          setTimeout(function() { isFilteringSlides = false; restoreVariantChangedDispatch(); }, 700);
        });
      });

      sizeSkuArr.forEach(function(radio) {
        sparkListen(radio, 'change', function() {
          if (radio.closest && radio.closest('li.disabled')) return;
          selectedImage = false;
          forClickSize = radio.value;
          isFilteringSlides = true;
          const position = parseInt(radio.getAttribute('data-option-position'), 10) || 2;
          const options = getMediaOptionsWithOverride(position, radio.value);
          updateDesktopGalleryGrid(options);
          filterSlidesInFlickity(options);
          setTimeout(function() { isFilteringSlides = false; restoreVariantChangedDispatch(); }, 700);
        });
      });

      colorSwatches.forEach(function(elem) {
    	sparkListen(elem, "click", function (e) {
          let colorSku = elem.querySelector("span").innerText;
          forClick = elem.querySelector("span").innerText;
          
          // Preserve the current size selection
          if (!forClickSize) {
              const currentSizeRadio = pdpQuery('.ProductForm .SizeSwatch__Radio:checked:not([data-product-set-member])');
              if (currentSizeRadio) {
                  const sizeLabel = currentSizeRadio.nextElementSibling;
                  forClickSize = sizeLabel ? sizeLabel.innerText : currentSizeRadio.value;
              }
          }
              
            // Gallery filter runs on ColorSwatch__Radio change (after radio is checked)
            
            // Check if current size is available for the new color, if not switch to first available
            setTimeout(() => {
                if (!isSparkGenerationCurrent()) return;
                const currentSize = $(".ProductForm .SizeSwatch__Radio:checked:not([data-product-set-member])").val();
                
                if (currentSize) {
                    // Check if current size + new color combination is available
                    const variantName = `${forClick} / ${currentSize}`;
                    let variantExists = variants.find(v => v.title === variantName && v.available);
                    
                    // If not found by title, try matching by option1/option2 (for German version)
                    if (!variantExists) {
                        variantExists = variants.find(v => v.option1 === forClick && v.option2 === currentSize && v.available);
                    }
                    
                    
                    if (!variantExists) {
                        // Current size not available for this color, find first available size
                        let availableVariants = variants.filter(v => v.available && v.title.includes(forClick));
                        
                        // If no variants found by title, try by option1 (for German version)
                        if (availableVariants.length === 0) {
                            availableVariants = variants.filter(v => v.available && v.option1 === forClick);
                        }
                        
                        
                        if (availableVariants.length > 0) {
                            // Get all available sizes for this color
                            const availableSizes = [];
                            availableVariants.forEach(variant => {
                                const parts = variant.title.split(" / ");
                                // Find the part that's NOT the color (should be the size)
                                const sizePart = parts.find(part => part !== forClick);
                                if (sizePart && !availableSizes.includes(sizePart)) {
                                    availableSizes.push(sizePart);
                                }
                            });
                            
                            
                            if (availableSizes.length > 0) {
                                const firstAvailableSize = availableSizes[0];
                                
                                // Click the SizeSwatch label for the first available size
                                const sizeLabel = $(`.ProductForm .SizeSwatch__Radio[value="${firstAvailableSize}"]`).closest("li").find("label.SizeSwatch");
                                if (sizeLabel.length > 0) {
                                    sizeLabel[0].click();
                                }
                                
                            }
                        }
                    }
                }
            }, 200);

        });
      });

      sizeSwatches.forEach(function(elem) {
    	sparkListen(elem, "click", function (e) {
          // Preserve the current color selection
          if (!forClick) {
              const currentColorRadio = pdpQuery('.ProductForm .ColorSwatch__Radio:checked');
              if (currentColorRadio) {
                  forClick = currentColorRadio.nextElementSibling.querySelector("span").innerText;
              }
          }
          // Gallery filter runs on SizeSwatch__Radio change (after radio is checked)
        });
      });

      } // end else (color/size swatch mode)

    // Remove existing Flickity thumbnail click handlers
    const productSection = pdpQuery('.Product');
    if (productSection && productSection._productSection) {
      // Remove the existing thumbnail click handler from theme.js
      productSection._productSection.delegateElement.off('click', '.Product__SlideshowNavImage');
    }

    // Regular PDP: per-thumb handlers navigate by current Flickity cell index.
    // Product Set uses capture delegation on the set root instead (bound above).
    if (!document.querySelector('[data-product-set-root]')) {
    pdpQueryAll('.Product__SlideshowNavImage').forEach(function(thumb, thumbIndex) {
      
      sparkListen(thumb, "click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Set flag to indicate manual click
        isManualThumbClick = true;
          
          // Remove selected class from all thumbnails
          pdpQueryAll('.Product__SlideshowNavImage').forEach(function(elem) {
            elem.classList.remove('is-selected');
          });
          
          // Add selected class to clicked thumbnail
          this.classList.add('is-selected');
          
          // Get the image from the thumbnail
          const thumbImg = this.querySelector('img');
          if (!thumbImg) return;
          
          const thumbAlt = thumbImg.getAttribute('alt');
          if (!thumbAlt) return;
          
          // Find the corresponding slide in Flickity
          const flkty = Flickity.data($('.Product__Slideshow')[0]);
          if (!flkty) return;
          
          // Use data-media-id to find the correct slide
          const thumbMediaId = this.getAttribute('data-media-id');
          
          // Find the slide with matching data-media-id
          let targetSlideIndex = -1;
          flkty.cells.forEach((cell, index) => {
            const slideMediaId = cell.element.getAttribute('data-media-id');
            if (slideMediaId === thumbMediaId) {
              targetSlideIndex = index;
            }
          });
          
          
          if (targetSlideIndex >= 0) {
            // Hide all slides first
            flkty.cells.forEach((cell, index) => {
              cell.element.classList.add('Product__SlideItem--hidden');
            });
            
            // Show only the target slide
            const targetSlide = flkty.cells[targetSlideIndex].element;
            targetSlide.classList.remove('Product__SlideItem--hidden');
            
            flkty.select(targetSlideIndex, true, true);
          } else {
          }
          
          // Reset flag after a short delay
          setTimeout(() => {
            isManualThumbClick = false;
          }, 100);
        });
      });
    }

      function SwitchersHandler(){
        currentElColor = pdpQuery('.ProductForm .ColorSwatch.is-selected');
        currentElSize = pdpQuery('.ProductForm .SizeSwatch.is-selected');

        let isSelectedImage = pdpQuery('.Product__SlideItem--image.is-selected');
        if (!isSelectedImage) return; // No selected image yet
        
        const img = isSelectedImage.querySelector('img');
        if (!img) return; // Image not loaded yet
        
        const slideAlt = img.getAttribute('alt');
        if (!slideAlt && img.hasAttribute('data-src')) {
            // Still lazy loading, skip this iteration
            return;
        }

        // Check if current slide matches current filter - if not, don't change options
        const slideAltTrimmed = (slideAlt || '').trim();
        const productData = getProductData();
        const product = productData && productData.product;
        const currentOptions = getSelectedMediaOptionsFromForm();
        let slideMatchesFilter = false;
        
        if (isAltEffectivelyEmpty(slideAltTrimmed, productTitle)) {
            slideMatchesFilter = true;
        } else {
            slideMatchesFilter = shouldShowMediaForAlt(slideAltTrimmed, currentOptions, productTitle);
        }
        
        // REMOVED: All automatic option switching functionality
      }

      var flickityViewport = pdpQuery('.Product__Slideshow .flickity-viewport') || document.querySelector('.flickity-viewport');
      sparkListen(flickityViewport, 'touchend', function (event) {
        setTimeout(() => {
            if (!isSparkGenerationCurrent()) return;
            SwitchersHandler();
        }, 800);
      });


      navButtons.forEach(function(elem) {
        sparkListen(elem, "click", function(e) {
            setTimeout(() => {
                if (!isSparkGenerationCurrent()) return;
                SwitchersHandler();
            }, 800);
        });
      });

    }
}

// Simple initialization like the old code
document.addEventListener("DOMContentLoaded", function(){
    initializeSparkPawsTheme();
});

document.addEventListener('product-set:hero-dismissed', function () {
  if (!document.querySelector('[data-product-set-root]')) return;
  // After hero removal, force Flickity onto the first valid Dog/Human slide.
  if (typeof window.__sparkPawsEnsureProductSetGallerySelection === 'function') {
    try { window.__sparkPawsEnsureProductSetGallerySelection(); } catch (e) {}
  }
});

document.addEventListener('product-set:content-replaced', function (event) {
  if (!document.querySelector('[data-product-set-root]')) return;

  var active = event.detail && event.detail.active;
  if (!active) return;

  // Re-bind global variants/options used by SparkPaws custom handlers from embedded JSON
  var variantJson = active.querySelector('[data-product-set-variants]');
  if (variantJson) {
    try {
      var parsed = JSON.parse(variantJson.textContent);
      if (parsed.variants) window.variants = parsed.variants;
      if (parsed.options) window.options = parsed.options;
    } catch (e) {}
  }

  // Full theme reinit: new AbortController generation, fresh allSlidesCache from the
  // active member DOM, Flickity wait + initial media filter, option handlers rebound.
  // Do not call __sparkPawsApplyProductSetMediaFilter afterward — that re-ran
  // initializeSlideCache after the first filter and discarded disconnected slides.
  if (typeof initializeSparkPawsTheme === 'function') {
    try { initializeSparkPawsTheme(); } catch (e) {}
  }
});
